// extracted by mini-css-extract-plugin
export default {"navigation-bar__icon-selected":"navigationBar_navigation-bar__icon-selected__9PJPw"};